<!-- email-composer.component.html -->
<div class="email-composer">
  <div class="composer-header">
    <div class="header-content">
      <div class="header-icon">✉️</div>
      <h1 class="header-title">Nuevo Email</h1>
    </div>
  </div>

  <div class="composer-body">
    <div 
      class="success-message" 
      [style.display]="showSuccessMessage ? 'flex' : 'none'">
      <span>✅</span>
      <span>Email enviado exitosamente</span>
    </div>

    <form [formGroup]="emailForm" (ngSubmit)="sendEmail()">
      <!-- Destinatarios -->
      <div class="form-group">
        <label class="form-label" for="recipients">Para</label>
        <div class="recipients-container">
          <input 
            type="email" 
            id="recipients" 
            class="form-input" 
            placeholder="Ingresa el email del destinatario"
            [(ngModel)]="recipientInput"
            (keypress)="onRecipientKeyPress($event)"
            [ngModelOptions]="{standalone: true}">
          <div class="form-hint">
            💡 Presiona Enter para agregar múltiples destinatarios
          </div>
          <div class="recipients-tags">
            @for(recipient of recipients; track recipient) {
              <div class="recipient-tag">
                <span>{{ recipient }}</span>
                <span class="remove-tag" (click)="removeRecipient(recipient)">×</span>
              </div>
            }
          </div>
          <button 
            type="button" 
            class="add-recipient-btn" 
            (click)="addRecipient()">
            <span>➕</span>
            Agregar destinatario
          </button>
        </div>
      </div>

      <!-- Asunto -->
      <div class="form-group">
        <label class="form-label" for="subject">Asunto</label>
        <input 
          type="text" 
          id="subject" 
          class="form-input" 
          placeholder="Escribe el asunto del email"
          formControlName="subject"
          (input)="autoSaveDraft()">
        <div class="form-hint">
          📝 Un asunto claro mejora la tasa de apertura
        </div>
        @if(emailForm.get('subject')?.invalid && emailForm.get('subject')?.touched) {
          <div class="error-message">El asunto es requerido</div>
        }
      </div>

      <!-- Mensaje -->
      <div class="form-group" style="position: relative;">
        <label class="form-label" for="body">Mensaje</label>
        <textarea 
          id="body" 
          class="form-textarea" 
          placeholder="Escribe tu mensaje aquí..."
          formControlName="body"
          (input)="updateCharacterCount(); autoSaveDraft()"></textarea>
        <div class="character-count" [style.color]="getCharCountColor()">
          {{ characterCount }} caracteres
        </div>
        <div class="form-hint">
          ✨ Tip: Mantén el mensaje claro y conciso
        </div>
        @if(emailForm.get('body')?.invalid && emailForm.get('body')?.touched) {
          <div class="error-message">El mensaje es requerido</div>
        }
      </div>

      <!-- Botones de acción -->
      <div class="form-actions">
        <button 
          type="submit" 
          class="btn btn-primary"
          [disabled]="emailForm.invalid || recipients.length === 0 || isLoading">
          @if(isLoading) {
            <span>⏳</span>
            Enviando...
          } @else {
            <span>📤</span>
            Enviar Email
          }
        </button>
        <button 
          type="button" 
          class="btn btn-secondary" 
          (click)="saveDraft()"
          [disabled]="isLoading">
          @if(draftSaved) {
            <span>✅</span>
            Guardado
          } @else {
            <span>💾</span>
            Guardar Borrador
          }
        </button>
        <button 
          type="button" 
          class="btn btn-secondary" 
          (click)="clearForm()"
          [disabled]="isLoading">
          <span>🗑️</span>
          Limpiar
        </button>
      </div>
    </form>
  </div>
</div>